import useAxios from '../../utils/useAxios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { rejectWithApiError } from '../../utils/reduxErrors'

export const getDealerGroups = createAsyncThunk('dealergroups/get', async (...args) => {
  try {
    const axios = useAxios()
    const { data } = await axios.get('/api/dealergroups/')
    return data
  } catch (error) {
    const { rejectWithValue } = args[1]
    return rejectWithApiError(rejectWithValue, error)
  }
})

export const saveDealerGroup = createAsyncThunk(
  'dealergroup/save',
  async (t, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.put(`/api/dealergroups/${t.id}/`, t)
      return data
    } catch (error) {
      return rejectWithApiError(rejectWithValue, error)
    }
  },
)

export const createDealerGroup = createAsyncThunk(
  'dealergroup/create',
  async (t, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.post('/api/dealergroups/', t)
      return data
    } catch (error) {
      return rejectWithApiError(rejectWithValue, error)
    }
  },
)

export const deleteDealerGroup = createAsyncThunk(
  'dealergroup/delete',
  async (t, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.delete(`/api/dealergroups/${t.id}/`)
      return data
    } catch (error) {
      return rejectWithApiError(rejectWithValue, error)
    }
  },
)
